import { render, staticRenderFns } from "./render-tab.vue?vue&type=template&id=5e361661&scoped=true"
import script from "./render-tab.vue?vue&type=script&lang=js"
export * from "./render-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e361661",
  null
  
)

export default component.exports